/**
 * ArticleList — konfigurationskonstanter
 *
 * Root paths:
 *   Bruges i Phase 1 som fallback, og til test-sider i disconnected mode.
 *   I Phase 2 aflæses root path fra Sitecore-datasourcens 'Root Path' Droptree-felt.
 *
 * API-nøgle:
 *   Håndteres globalt af Apollo Client via GraphQLClientFactory.js.
 *   Konfigureres via miljøvariabel — sæt i .env.local:
 *     VITE_SITECORE_API_HOST=<https://sitecore-host>
 *     VITE_SITECORE_API_KEY=<api-key>
 *   Produktions-API-nøgle sættes tilsvarende i .env.production.
 */

export const ROOT_PATHS = {
  PRESSEMEDDELELSER: '/sitecore/content/rddk/da/Realkredit Danmark/Pressemeddelelser',
  SELSKABSMEDDELELSER: '/sitecore/content/rddk/da/Realkredit Danmark/Selskabsmeddelelser',
  COMPANY_ANNOUNCEMENTS: '/sitecore/content/rddk/da/Investor/Reports/Company announcements',
} as const;

/** Fallback hvis 'Root Path'-feltet ikke er sat på datasourcen */
export const DEFAULT_ROOT_PATH = ROOT_PATHS.PRESSEMEDDELELSER;
